// 403 — signed in to Keycloak (waffy-staff) but lacking a command-center role.
// Access requires the staff-ops OR staff-engineer-lead realm role
// (see WaffyCTO/initiatives/07-waffy-sso/design/04-realm-topology.md).

import { useAuth } from "./AuthContext";
import { ALLOWED_ROLES } from "./oidc";

interface Props {
  roles: string[];
  user: string;
}

export function ForbiddenPage({ roles, user }: Props) {
  const { logout } = useAuth();
  return (
    <div className="login-shell">
      <div className="login-card">
        <div className="login-brand">
          <div>
            <div className="brand-name">403 — Access denied</div>
            <div className="brand-sub">Waffy Command Center</div>
          </div>
        </div>
        <p>
          You are signed in as <code>{user}</code>, but your account does not have a
          role permitted to use the Command Center.
        </p>
        <p>
          Required (one of): <code>{ALLOWED_ROLES.join(" / ")}</code>.
          <br />
          Your roles: <code>{roles.length ? roles.join(", ") : "(none)"}</code>
        </p>
        <p className="login-foot">
          Ask in <code>#ops</code> to be added to the <code>ops@waffyapp.com</code> or{" "}
          <code>eng-leads@waffyapp.com</code> Google group.
        </p>
        <button className="btn-primary login-submit" onClick={() => void logout()}>
          Sign out
        </button>
      </div>
    </div>
  );
}
